<script setup>
import { computed } from 'vue'

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
})

const countdown = computed(() => {
  const countdownData = props.item.enrichment.nextAttemptCountdown
  return {
    hours: (countdownData.days * 24 + countdownData.hours).toString().padStart(2, '0'),
    minutes: countdownData.minutes.toString().padStart(2, '0'),
    seconds: countdownData.seconds.toString().padStart(2, '0'),
  }
})
</script>

<template>
  <div v-if="props.item.enrichment.nextAttemptCountdown" class="text-[18rem] font-cervo-mono tracking-[-3px]">
    <div class="absolute left-[525px] top-[700px] text-q-cr-gray-primary leading-[.5em] text-center flex gap-[30px]">
      <div class="w-[310px]">{{ countdown.hours }}</div>
      <div class="w-[310px]">{{ countdown.minutes }}</div>
      <div class="w-[310px]">{{ countdown.seconds }}</div>
    </div>
  </div>
</template>
